import { render } from "./crmList.vue?vue&type=template&id=1b81c01e&scoped=true"
import script from "./crmList.vue?vue&type=script&lang=js"
export * from "./crmList.vue?vue&type=script&lang=js"

import "./crmList.vue?vue&type=style&index=0&id=1b81c01e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b81c01e"]])

export default __exports__